/**
 * Design-board route (clawinstall-customer) — eagerly registers the file route
 * with its production gate and search validation; the frame registry and all 97
 * board components are deferred to the `.lazy.tsx` twin so the scoped capture
 * CSS and the frame components never reach the always-loaded main chunk.
 *
 * The board renders the frozen design capture in docs/design/clawinstall-customer
 * for the pixel-convergence loop (scripts/design-board-sweep.ts) and for
 * eyeballing frames during /design-wire. It is not a product surface:
 * production requests 404 via `beforeLoad`, while dev (`development`) and
 * preview (`preview`) keep it reachable from the same build artifact.
 *
 * @since 1.0.0
 */
import { createFileRoute, notFound } from "@tanstack/react-router";

import { runtimeNodeEnv, shouldHideDesignBoard, validateDesignBoardSearch } from "~/lib/design-board.ts";

export const Route = createFileRoute("/design-board/clawinstall-customer")({
  beforeLoad: () => {
    if (shouldHideDesignBoard(runtimeNodeEnv())) {
      throw notFound();
    }
  },
  validateSearch: validateDesignBoardSearch,
});
